export default __webpack_public_path__ + "static/media/Expedición cerebro.529dfbef.png";